/* eslint-disable no-unused-vars */
import qs from 'qs';
import { storage } from '@rio-cloud/rio-uikit/storageUtils';

const PREFIX = 'featureToggle.';

const detectFeatureToggles = () => {
    const detectToggle = (transform: Function, name: string) => {
        const [_, searchParams = ''] = window.location.hash.split('?');
        const params = qs.parse(searchParams);

        const toggleValue = params[name] as string;
        const value = toggleValue ? storage.save(name, toggleValue, PREFIX) : storage.load(name, PREFIX);

        return value && transform(value);
    };

    const BooleanToggle = (value: any) => {
        return value === 'true' || value === '1';
    };

    return {
        poc: false, //detectToggle(BooleanToggle, 'ft_poc'),
        hideFeedback: true, //detectToggle(BooleanToggle, 'ft_hide_feedback'),
    };
};

export const featureToggles = detectFeatureToggles();
